module.exports = __webpack_public_path__ + "static/media/decodificador_d.8189f857.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/decodificador_d.png
// module id = 1166
// module chunks = 0